import request from '@/utils/request' //引入封装好的 axios 请求
//列表
export function authMangList(data = {}) {
    return request({
        url: '/api/v1/license/selectLicenseList',
        method: 'post',
        data: data
    })
}
export function selectQueryNumList(data = {}) {
    return request({
        url: '/api/v1/license/selectQueryNumList',
        method: 'post',
        data: data
    })
}
// 详情
export function authMangDetail(id) {
    return request({
        url: `/api/v1/license/selectLicenseDetail`,
        method: 'post',
        data: id
    })
}
//授权企业书导出
export function authMangExport(data) {
    return request({
        url: `/api/v1/license/licensedDataExport`,
        method: 'post',
        data: data,
        responseType: 'blob'
    }).then(response => {
        // 从响应头解析文件名
        const disposition = response.headers['content-disposition']
        let filename = '授权企业导出.xlsx'
        if (disposition) {
            const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i)
            filename = utf8Match[1]
                ? decodeURIComponent(utf8Match[1])
                : disposition.match(/filename="?([^;"]+)"?/i)[1].replace(/"/g, '') || filename
        }
        return {
            filename,
            blobData: response.data,
            contentType: response.headers['content-type']
        }
    })
}
//授权数据导出
export function authMangExportData(data) {
    return request({
        url: `/api/v1/license/licenseDataExport`,
        method: 'post',
        data: data,
        responseType: 'blob'
    }).then(response => {
        // 从响应头解析文件名
        const disposition = response.headers['content-disposition']
        let filename = '授权数据导出.xlsx'
        if (disposition) {
            const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i)
            filename = utf8Match[1]
                ? decodeURIComponent(utf8Match[1])
                : disposition.match(/filename="?([^;"]+)"?/i)[1].replace(/"/g, '') || filename
        }
        return {
            filename,
            blobData: response.data,
            contentType: response.headers['content-type']
        }
    })
}
// 协议上传
export function authUpload(data) {
    return request({
        url: `/api/v1/license/uploadLicenseList`,
        method: 'post',
        data: data
    })
}
// 协议撤销
export function authClose(data = {}) {
    return request({
        url: `/api/creditInquiry/cancelLicense`,
        method: 'post',
        data: data
    })
}
// 信易贷数据上报上传
export function dataUpload(data) {
    return request({
        url: `/api/v1/bankLicense/uploadLoanInfo`,
        method: 'post',
        data: data
    })
}
// 信易贷历史记录
export function historydata(data) {
    return request({
        url: `/api/v1/bankLicense/selectUploadHis`,
        method: 'post',
        data: data
    })
}
// 历史记录下载
export function historyDownload(data) {
    return request({
        url: `/api/v1/bankLicense/downloadHisInfo`,
        method: 'post',
        data: data,
        responseType: 'blob'
    }).then(response => {
        // 从响应头解析文件名
        const disposition = response.headers['content-disposition']
        let filename = '信易贷数据下载.xlsx'
        if (disposition) {
            const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i)
            filename = utf8Match[1]
                ? decodeURIComponent(utf8Match[1])
                : disposition.match(/filename="?([^;"]+)"?/i)[1].replace(/"/g, '') || filename
        }
        return {
            filename,
            blobData: response.data,
            contentType: response.headers['content-type']
        }
    })
}